import { palette } from './palette';
import background from 'assets/images/faq-banner-img.webp'

export const homeStyle = {
  '.drawer-wrapper': {
    '& .drawer-title-container, .drawer-close-button': {
      color: palette.text.highlight,
    },
  },
  '.popup-action-button': {
    color: palette.primary.contrastText
  },

  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,

      '& .hero-shaped__left-side': {
        flex: '0 0 50%',
        maxWidth: '50%',
  
        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },
  
        '& .hero-shaped__image': {
          width: '50vw',
          
          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          }
        },
      },
    }
  },

  '.active-container': {
    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      background: palette.background.main,

      '@media(min-width: 900px)': {
        marginBottom: '60px',
      },

      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,

        '& .section-alternate__content': {
          '@media(min-width: 900px)': {
            padding: '0 48px',
          },
        },
        '& .hero-title': {
          lineHeight: '55px',

          '@media(min-width: 900px)': {
            lineHeight: '80px',
          },
        },
        '& .hero-subtitle': {
          maxWidth: 450
        },
      },
      '& .image-wrapper': {
        position: 'relative',
        '@media(min-width: 900px)': {
          bottom: -85,
        },
  
        '& .image': {
          borderRadius: 32,
          boxShadow: 'none',
          height: 642,
          
          '@media(min-width: 900px)': {
            width: 'auto',
          },
          '@media(max-width: 900px)': {
            height: 450,
          }
        },
      },
    },

    /* Benefits - Styles */
    '& #definition-section': {
      '& .benefits-wrapper': {
        padding: '0 24px',

        '& .image': {
          borderRadius: 32,
        },
        '& .definition-service-tile': {
          padding: '0px 14px'
        },

        '@media(min-width: 900px)': {
          '& .customImageWrapper': {
            '& .image': {
              borderRadius: 32,
              height: 560,
              width: 500
            },
          },
        },
        '@media(max-width: 900px)': {
          '& .service-tile-wrapper': {
            marginBottom: 10
          },
          '& .section-header__title': {
            marginBottom: 20
          },
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        backgroundColor: palette.background.main,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          '&:hover': {
            background: palette.primary.light,
            color: palette.text.primary,
          }
        },
        '@media(min-width: 900px)': {
          marginTop: 10,
          borderTop: `1px solid ${palette.secondary.main}`,
        },

        '& .subscription-section': {
          '@media(min-width: 900px)': {
            marginTop: 10,
            borderTop: `1px solid ${palette.secondary.main}`,
          },

          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
        },
        '& .savings-summary-link': {
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,
      '& .howitworks-title': {
        marginBottom: 0,
      },
      '& .how-cover-image': {
        height: 550,
      },
      '& .step-counter': {
        backgroundColor: palette.secondary.main,
        fontSize: 16,
      },
      '& .step-content': {
        maxWidth: 400
      }
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .service-plan-table': {
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`
        },
        '& .savings-header': {
          color: palette.text.primary
        }
      },
      '& .savings-contact-card': {
        background: palette.background.footer
      }
    },

    /* Static Page Hero Banners */
    '& .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .savings-hero-section, .find-provider-section, & .plan-selection-section, & .checkout-hero-section': {
      background: palette.background.header,
    },
    '& .book-appointment-hero-section': {
      height: '100%',
      backgroundColor: palette.background.main,
      
      '& .MuiTypography-root': {
        color: palette.text.primary,
      }
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: 'unset',
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      background: palette.background.main,
      '& .section-header__title-wrapper > h3': {
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '0px',
          left: '35%',
          height: '2px',
          width: '29%',
        },
      },
      '@media(min-width: 900px)': {
        padding: 22,
      },
      '& .MuiAvatar-root': {
        display: 'none',
      },
      '& .MuiTypography-colorTextPrimary': {
        textAlign: 'center',
      },
      '& .avatar-section': {
        paddingTop: '20px',
        order: 2,
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .section-header': {
        order: 1,
      },
      '& .MuiPaper-root': {
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .MuiRating-root': {
        marginTop: 'initial',
        order: 3,
      },
      '& .MuiPaper-rounded': {
        background: 'transparent',
      },
      '& .avatar-container': {
        padding: 0,
        marginBottom: '5px',
      },
      '& .testimonialSection': {
        padding: '40px 32px',
        '@media(min-width: 900px)': {
          padding: '40px 16px',
        },
        '& .react-multiple-carousel__arrow': {
          background: palette.background.arrow,
        },
        '& .react-multi-carousel-item': {
          '& .MuiPaper-root': {
            marginInline: 100
          },
          '@media(max-width: 900px)' : {
            '& .MuiPaper-root': {
              marginInline: 0
            },
          }
        }
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      backgroundImage: `url(${background})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',

      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        textAlign: 'left',
      },
      '& .header-container': {
        justifyContent: 'left',
        margin: '0',
      },
      '& .section': {
        marginLeft: 64
      },
      '@media(max-width: 900px)': {
        '& .section': {
          marginLeft: 0
        },
      }
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: 'rgba(71, 86, 112, 0.8)'
      }
    },
    '& .faq-contact-wrapper': {
      background: palette.background.main,
      '& .faq-contact-section': {
        '& .contact-img-wrapper': {
          width: '64px',
          maxWidth: '64px',
        },
        '& .contact-card-subtitle': {
          color: palette.text.light
        },
        '& .provider-contact-link': {
          color: palette.primary.main
        }
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .planCard': {
        '&:hover': {
          background: palette.primary.light,
          color: palette.text.primary,
        }
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .home-static-hero-wrapper': {
        '& .hero-static-bg': {
          backgroundColor: palette.background.main,
        },
      },
      '& .plans-wrapper': {
        '& .highlight-button': {
          backgroundColor: palette.text.highlight,
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled,
        },
      },
    },
 
    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      }
    },

    /* Disclosure Footer */
    '& .footer-wrapper, & .footer-wrapper a': {
      backgroundColor: 'unset'
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },
  },
};